import router from "@/router"
import { login, logout } from "@/api/auth"
import { getToken, setToken, removeToken } from "@/utils/token"

export default {
  namespaced: true,
  state: () => ({
    token: getToken() || null,
    userInfo: null,
    loginTime: null,
    tokenExpire: null, // TODO 如有需要，可结合后端返回的过期时间补齐续期相关逻辑  --Lix
    showWelcome: 1 // 登录后显示欢迎对话框
  }),
  getters: {
    isLogged: state => !!state.token,
    currentUser: state => state.userInfo,
    loginDuration: state => (state.loginTime ? Math.floor((Date.now() - state.loginTime) / 1000) : 0),
    currentShowWelcome: state => state.showWelcome
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = Object.freeze(userInfo)
    },
    SET_LOGIN_TIME: state => {
      state.loginTime = new Date().getTime()
    },
    SET_WELCOME_FLAGE: (state, showFlage) => {
      state.showWelcome = showFlage
    },
    CLEAR_AUTH: state => {
      state.token = null
      state.userInfo = null
      state.loginTime = null
      state.showWelcome = 1
      removeToken()
    },
    CLEAR_SHOWWELCOME: state => {
      state.showWelcome = 1
    }
  },
  actions: {
    async login({ commit }, datas) {
      try {
        const res = await login(datas)
        commit("SET_TOKEN", res.data.token)
        commit("SET_USER_INFO", { ...res.data })
        commit("SET_LOGIN_TIME")
        router.replace(router.currentRoute.query.redirect || "/home")
        return res
      } catch (error) {
        removeToken()
        return Promise.reject(error)
      }
    },

    saveloginInfoByOkta({ commit }, data) {
      console.log("saveloginInfoByOkta", data)
      try {
        commit("SET_TOKEN", data.token)
        commit("SET_USER_INFO", { ...data })
        commit("SET_LOGIN_TIME")
        router.replace(router.currentRoute.query.redirect || "/home")
      } catch (error) {
        console.log("saveloginInfoByOkta-error", error)
        removeToken()
      }
    },

    async logout({ commit }) {
      try {
        await logout()
      } finally {
        commit("CLEAR_AUTH")
        router.replace("/login")
      }
    },

    // TODO 如有需要，可结合后端返回的过期时间补齐续期相关逻辑  --Lix
    async refreshToken({ commit, state }) {
      if (!state.token) return
      const { data } = await refreshTokenAPI(state.token)
      commit("SET_TOKEN", data.newToken)
      return data.newToken
    },

    storeWelcomeFlage({ commit }, data) {
      commit("SET_WELCOME_FLAGE", data)
    },
    storeUserInfo({ commit }, data) {
      commit("SET_USER_INFO", data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js